export default __webpack_public_path__ + "static/media/1_besafe.5f69a83d.svg";